import React from 'react';
import { Helmet } from 'react-helmet-async';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 40 }}>
    <h2 style={{ fontSize: '1.25rem', color: '#0C447C', marginBottom: 12 }}>{title}</h2>
    {children}
  </div>
);

const p = { fontSize: '0.96rem', color: '#64748B', lineHeight: 1.8, marginBottom: 12 };
const li = { fontSize: '0.96rem', color: '#64748B', lineHeight: 1.8, marginBottom: 6 };

export default function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Sagient Partners</title>
        <meta name="description" content="Privacy Policy for Sagient Partners - how we collect, use, and protect your information." />
        <link rel="canonical" href="https://sagientpartners.com/privacy" />
      </Helmet>

      {/* Header */}
      <section style={{ background: 'linear-gradient(135deg, #0C447C 0%, #0A1628 100%)', padding: '80px 0 64px', color: '#fff' }}>
        <div className="container">
          <p className="section-label" style={{ color: '#B5D4F4' }}>Legal</p>
          <h1 style={{ color: '#fff', marginBottom: 16 }}>Privacy Policy</h1>
          <p style={{ color: '#B5D4F4', fontSize: '1rem' }}>Last updated: July 8, 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container" style={{ maxWidth: 760 }}>

          <Section title="Overview">
            <p style={p}>
              Sagient Partners ("we," "us," or "our") operates the website sagientpartners.com. This Privacy Policy describes how we collect, use, and protect information you provide when using our website or contacting us.
            </p>
          </Section>

          <Section title="Information We Collect">
            <p style={p}><strong style={{ color: '#0A1628' }}>Contact form submissions.</strong> When you fill out our discovery call request form, we collect your name, email address, company name, company size, service interest, and the message you provide. This information is used solely to respond to your inquiry.</p>
            <p style={p}><strong style={{ color: '#0A1628' }}>Usage data.</strong> We use Google Analytics (via Google Tag Manager) to collect anonymized data about how visitors use our website, including pages visited, time on site, and general geographic location. This data does not identify you personally.</p>
          </Section>

          <Section title="How We Use Your Information">
            <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
              <li style={li}>To respond to your contact form inquiry and schedule a discovery call</li>
              <li style={li}>To understand how visitors use our website and improve the content we offer</li>
              <li style={li}>To communicate with you about our services if you have expressed interest</li>
            </ul>
            <p style={p}>We will not send you marketing emails without your explicit consent.</p>
          </Section>

          <Section title="Cookies">
            <p style={p}>Our website uses the following types of cookies:</p>
            <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
              <li style={li}><strong style={{ color: '#0A1628' }}>Necessary Cookies</strong> - essential for basic website functionality, such as navigating between pages and accessing secure areas. The website cannot function properly without these cookies.</li>
              <li style={li}><strong style={{ color: '#0A1628' }}>Analytics Cookies</strong> - used to understand how visitors interact with our website, including pages visited, time on site, and general geographic location. This data is aggregated and does not identify you personally.</li>
            </ul>
            <p style={p}>You can disable cookies in your browser settings. Disabling analytics cookies will not affect your ability to use the website. You may also opt out of Google Analytics tracking at <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer" style={{ color: '#378ADD' }}>tools.google.com/dlpage/gaoptout</a>.</p>
          </Section>

          <Section title="Data Storage and Security">
            <p style={p}>
              Contact form submissions are transmitted via a secure cloud function to our email inbox at info@sagientpartners.com. We do not store form submissions in a database. Email correspondence is retained in our email system and treated as confidential business communication.
            </p>
            <p style={p}>
              Our website is served over HTTPS. We take reasonable technical measures to protect your information, but no transmission over the internet is 100% secure.
            </p>
          </Section>

          <Section title="Sharing of Information">
            <p style={p}>
              We work with a limited number of trusted vendors who help us operate our website and run our business. This includes services such as website hosting, analytics, and email delivery. Where these vendors handle any information you have provided to us, they do so strictly on our behalf and only for the purpose we hired them for.
            </p>
            <p style={p}>
              We do not sell your personal information or share it with third parties for their own marketing purposes.
            </p>
          </Section>

          <Section title="California Privacy Rights (CCPA)">
            <p style={p}>
              If you are a California resident, you have the right to request information about the personal data we have collected about you, request deletion of your personal data, and opt out of any sale of personal data (we do not sell personal data).
            </p>
            <p style={p}>
              To exercise these rights, contact us at <a href="mailto:info@sagientpartners.com" style={{ color: '#378ADD' }}>info@sagientpartners.com</a>.
            </p>
          </Section>

          <Section title="Children's Privacy">
            <p style={p}>
              Our website is not directed to children under 13. We do not knowingly collect personal information from children.
            </p>
          </Section>

          <Section title="Changes to This Policy">
            <p style={p}>
              We may update this Privacy Policy from time to time. The date at the top of this page reflects the most recent revision. Continued use of the website after changes are posted constitutes acceptance of the updated policy.
            </p>
          </Section>

          <Section title="Contact Us">
            <p style={p}>
              If you have questions about this Privacy Policy or how we handle your information, please contact us at:
            </p>
            <p style={{ ...p, marginBottom: 4 }}><strong style={{ color: '#0A1628' }}>Sagient Partners</strong></p>
            <p style={{ ...p, marginBottom: 4 }}>San Francisco Bay Area, California</p>
            <p style={p}><a href="mailto:info@sagientpartners.com" style={{ color: '#378ADD' }}>info@sagientpartners.com</a></p>
          </Section>

        </div>
      </section>
    </>
  );
}
